<template>
  <div class="mine-page">
    <!-- iQIYI Logo -->
    <img src="/img/iqiyi.png" alt="logo" class="iqiyi-logo" />
    <!-- 用户信息 -->
    <div class="user-header">
      <div class="user-avatar">
        <img src="/img/logo.png" />
      </div>
      <div class="user-info">
        <div class="username">{{ userInfo.username }}</div>
        <div class="vip-text">{{ $t('my.vip_text') }}</div>
      </div>
      <img src="/img/neww/vip.png" class="vip-badge"/>
    </div>

    <!-- 余额卡片 -->
    <div class="balance-card">
      <div class="balance-header">
        <span class="balance-label">{{ $t('my.balance') }} HKD {{ showBalance ? (userInfo.money || '0.00') : '****' }}</span>
        <div class="balance-icons">
          <van-icon :name="showBalance ? 'eye-o' : 'closed-eye'" class="icon-eye-btn" @click="toggleBalance" />
          <van-icon name="replay" class="icon-refresh-btn" @click="getUserInfo" />
        </div>
      </div>
    </div>
    <div class="btn-actions">
      <div class="action-btn recharge" @click="doPay">{{ $t('my.recharge') }}</div>
      <div class="action-btn withdraw" @click="doWithdrawal">{{ $t('my.withdraw') }}</div>
    </div>
    <!-- 功能按钮网格 -->
    <div class="function-grid">
      <div class="function-item" @click="goTo('/GameRecord')">
		<img src="/img/neww/ico_bb.png" class="function-icon"/>
        <div class="function-text">{{ $t('my.game_record') }}</div>
      </div>
      <div class="function-item" @click="goTo('/Log')">
		<img src="/img/neww/ico_zdjl.png" class="function-icon"/>
        <div class="function-text">{{ $t('my.bill_record') }}</div>
      </div>
      <div class="function-item" @click="goTo('/WithdrawRecord')">
		<img src="/img/neww/ico_tkjl.png" class="function-icon"/>
        <div class="function-text">{{ $t('my.withdraw_record') }}</div>
      </div>
      <div class="function-item" @click="goTo('/RechargeList')">
		<img src="/img/neww/ico_czjl.png" class="function-icon"/>
        <div class="function-text">{{ $t('my.recharge_record') }}</div>
      </div>
      <div class="function-item" @click="exit">
		<img src="/img/neww/ico_txzx.png" class="function-icon"/>
        <div class="function-text">{{ $t('my.safe_exit') }}</div>
      </div>
    </div>

    <!-- 菜单列表 -->
    <div class="menu-list">
      <div class="menu-item" @click="doLogin">
        <span>{{ $t('my.personal_info') }}</span>
        <span class="arrow">&gt;</span>
      </div>
      <div class="menu-item" @click="goTo('/BindCard')">
        <span>{{ $t('my.my_bank_card') }}</span>
        <span class="arrow">&gt;</span>
      </div>
      <div class="menu-item" @click="goTo('/SetPayPassword')">
        <span>{{ $t('my.password_setting') }}</span>
        <span class="arrow">&gt;</span>
      </div>
      <div class="menu-item" @click="goTo('/Language')">
        <span>{{ $t('my.switch_language') }}</span>
        <span class="arrow">&gt;</span>
      </div>
    </div>

    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div class="nav-item" @click="goTo('/Home')">
        <img class="nav-icon" src="/img/footer/index.png" />
        <span class="nav-text">{{ $t('my.home') }}</span>
      </div>
      <div class="nav-item" @click="goTo('/Lottery')">
        <img class="nav-icon" src="/img/footer/yingyuan.png" />
        <span class="nav-text">{{ $t('my.video_zone') }}</span>
      </div>
      <div class="nav-item active">
        <img class="nav-icon" src="/img/footer/myed.png" />
        <span class="nav-text active">{{ $t('my.personal_center') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      showBalance: true
    };
  },
  methods: {
    goTo(path) {
      this.$router.push({ path: path });
    },
    exit() {
      localStorage.clear();
      this.$router.push({ path: '/Login' });
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    doPay() {
      this.$toast(this.$t('my.contact_customer_service'));
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data && res.data.is_bank) {
          this.$router.push({ path: '/Withdraw' });
        } else {
          this.$router.push({ path: '/BindCard' });
        }
      });
    },
    toggleBalance() {
      this.showBalance = !this.showBalance;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        }
      });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.$router.push({ path: '/Login' });
    }
  }
};
</script>

<style lang="less" scoped>
.mine-page {
  min-height: 100vh;
  background: #151515;
  padding-bottom: 70px;
  box-sizing: border-box;
  
}

.iqiyi-logo {
  width: 120px;
  height: 40px;
  margin:20px;
}

.user-header {
  display: flex;
  align-items: center;
  padding: 10px 20px 20px;
}

.user-avatar {
  width:120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  flex: 1;
}

.username {
  font-size: 36px;
  font-weight: 500;
  color: #fcd6a9;
  margin-bottom: 5px;
}

.vip-text {
  font-size: 24px;
  font-weight: 700;
  opacity:.7;
  color: #fcd6a9;
}

.vip-badge {
  
  width:40px;
}

.balance-card {
  background: #fff;
  border-radius: 30px 30px 0 0;
  margin: 0 20px 0;
  overflow: hidden;
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:20px 30px;
}

.balance-label {
  font-size: 28px;
  font-weight: 700;
  color: #333;
}

.balance-icons {
  display: flex;
  gap: 12px;
}

.icon-eye-btn, .icon-refresh-btn {
  font-size: 36px;
  color: #999;
  cursor: pointer;
}

.btn-actions{
	display: flex;
	justify-content: space-between;
	background-color: #fff;
}

.balance-actions {
  display: flex;
  border-top: 1px solid #e0e0e0;
}

.action-btn {
  flex: 1;
  width:49.5%;
  text-align: center;
  padding: 12px 0;
  font-size: 26px;
  color: #151515;
  background: #f1bf82;
  cursor: pointer;
}
.action-btn:first-child {
  border-right: 1px solid #fff;
  margin-right: 8px;
}

.function-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  padding:30px 20px 20px;
  background-color: #fff;
}

.function-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.function-icon {
  width: 70px;
  height: 70px;
  background: #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}


.function-text {
  font-size: 26px;
  color: #333;
}

.menu-list {
  padding: 0 0 120px;
  background-color: #fff;
  
}

.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}

.menu-item span {
  font-size:26px;
  color: #666;
}

.arrow {
  color: #999;
  font-size: 28px;
}

.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 55px;
  background: #151515;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.nav-icon {
  width: 22px;
  height: 22px;
  margin-bottom: 2px;
}

.nav-text {
  font-size: 28px;
  color: #666;
}

.nav-text.active {
  color: #00c853;
}
</style>
